import { render, staticRenderFns } from "./ModalStatusForm.vue?vue&type=template&id=a2a15c44"
import script from "./ModalStatusForm.vue?vue&type=script&lang=ts"
export * from "./ModalStatusForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports